(function(){
'use strict';

scEnv.$inject = ["$provide"];
function scEnv($provide) {
  $provide.constant('scEnv', SC.env);
}

angular.module('classy').config(scEnv);
})();